import { render, staticRenderFns } from "./ChatbotAiPrompt.vue?vue&type=template&id=44592a8b"
import script from "./ChatbotAiPrompt.vue?vue&type=script&lang=js"
export * from "./ChatbotAiPrompt.vue?vue&type=script&lang=js"
import style0 from "./ChatbotAiPrompt.vue?vue&type=style&index=0&id=44592a8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports